import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=a8c2963c&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=a8c2963c&lang=less&scoped=true&"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c2963c",
  null
  
)

export default component.exports